import { PciI } from "interfaces/Pci";
import { useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { AsyncSelect } from "components/AsyncInput/AsyncSelect";
import { getPciById, getPcis } from "services/pci";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { PCIDetailPanel } from "./PCIDetailPanel";

interface Props {
  onClose: () => void;
  elementoA: PciI | null;
  showModal: boolean;
}

const SEARCH_ROW_HEIGHT = "58px";

export const PCICompareModal = ({ elementoA, showModal, onClose }: Props) => {
  const [elementoB, setElementoB] = useState<PciI | null>(null);
  const [loadingB, setLoadingB] = useState(false);

  const handleSelectPciB = async (_event: any, original?: any) => {
    if (!original) {
      setElementoB(null);
      return;
    }

    try {
      setLoadingB(true);
      const pci = await getPciById(original.id);
      if (pci) {
        setElementoB(pci);
      }
    } catch (error) {
      showErrorToast("No fue posible cargar el PCI para comparar");
    } finally {
      setLoadingB(false);
    }
  };

  const handleClose = () => {
    setElementoB(null);
    onClose();
  };

  const pciSearchGetter = async (params: any) => {
    const response = await getPcis(params);
    return response;
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Comparar PCI</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {/* Mitad izquierda - Item A */}
          <Col
            md={6}
            style={{
              borderRight: "1px solid #dee2e6",
              paddingRight: "1.5rem",
            }}
          >
            <h5 className="mb-3 text-center" style={{ color: "#495057" }}>
              PCI A: {elementoA?.nombre}
            </h5>
            {/* Spacer para alinear con el AsyncSelect del lado B */}
            <div style={{ height: SEARCH_ROW_HEIGHT, marginBottom: "1rem" }}></div>
            <PCIDetailPanel elemento={elementoA} />
          </Col>

          {/* Mitad derecha - Item B */}
          <Col md={6} style={{ paddingLeft: "1.5rem" }}>
            <h5 className="mb-3 text-center" style={{ color: "#495057" }}>
              {elementoB ? `PCI B: ${elementoB.nombre}` : "PCI B"}
            </h5>

            <div style={{ height: SEARCH_ROW_HEIGHT, marginBottom: "1rem" }}>
              <AsyncSelect
                id="pci-compare-search"
                getter={pciSearchGetter}
                paramKey="nombre"
                arrElementsPath="elementos"
                optionsFormatConfig={{
                  label: (opt: any) => `${opt.nombre} (ID: ${opt.id})`,
                  value: "id",
                }}
                values={{}}
                onChange={handleSelectPciB}
                placeholder="Buscar PCI para comparar..."
                noOptionsMessage="No se encontraron PCI"
                emptySelectMessage="Escribí el nombre de un PCI"
                withDefaultInitialOptions={false}
              />
            </div>

            {loadingB && (
              <div className="d-flex justify-content-center py-5">
                <Spinner />
              </div>
            )}

            {!loadingB && elementoB && (
              <PCIDetailPanel elemento={elementoB} />
            )}

            {!loadingB && !elementoB && (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  minHeight: "200px",
                  color: "#adb5bd",
                }}
              >
                <p className="text-center">
                  Seleccioná un PCI del buscador para comparar.
                </p>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="mx-3"
          variant="secondary"
          size="lg"
          onClick={handleClose}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
